<template>
  <div v-wechat-title="title">
    <Header class="m-pc" :extras="extras" platform="pc"></Header>
    <template v-if="!errorMessage && !showInWechat">
      <div class="question-main">
        <div
          class="question-title"
          :style="{
            display:
              extraItem.extras('titlefont.display') == 1 ? 'block' : 'none',
            color: extraItem.extras('titlefont.color'),
            fontSize: pxOrVw(extraItem.extras('titlefont.size')),
            fontWeight:
              extraItem.extras('titlefont.weight') == 'default'
                ? '500'
                : extraItem.extras('titlefont.weight'),
          }"
        >
          {{ title }}
        </div>
        <pc-fields
          :form="questionnaireList"
          :extras="extras"
          :rulesJump.sync="rulesJump"
          ref="questionChild"
        />
      </div>
      <div class="question-footer" v-if="isShowBtn">
        <div
          class="question-footer-btn"
          @click="submit()"
          :style="{ cursor: isPreview ? 'not-allowed' : 'pointer' }"
        >
          提交
        </div>
      </div>
    </template>
    <div class="m-currency-content" v-if="errorMessage && !showInWechat">
      <form-status
        :status="
          questionaryStatus == 0
            ? 'nostart'
            : questionaryStatus == 2
            ? 'over'
            : 'error'
        "
        :test="errorMessage"
        platform="pc"
      ></form-status>
    </div>
    <WeChat v-if="showInWechat" :qrcodeUrl="qrcodeUrl" />
    <CountDown
      ref="count-down"
      :extras="extras"
      platform="pc"
      :totalTimeM="
        questionnaireInfo.isTimeLimit == '2' ? questionnaireInfo.limitTime : 0
      "
      :costTime="costTime"
      @calibration="questionnaireTimeGet"
      @autoSubmit="submit"
    ></CountDown>
  </div>
</template>

<script>
import questionaryMixin from "../../../mixins/questionary";
import templateMixin from "../../../mixins/exam-config";
import PcFields from "@/components/PcFields.vue";

export default {
  name: "examPcQuestionnaire",
  components: {
    PcFields,
  },
  mixins: [templateMixin, questionaryMixin],
};
</script>

<style scoped></style>
